import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Interfaces
import { IStore } from '../interfaces/StoreTypes';

// Redux Actions
import { fetchUserChannelsList } from '../store/reducers/liveTvSlice';

// Components
import Loader from '../components/Loader';
// import EpgTVContainer from '../components/ui/EPG';

// Helpers
import useCommon from '../hooks/helper/useCommon';
import usePPVConfig from '../hooks/usePPVConfig';
import { EpgGuideContainer } from '../features/epg/';
import { Skeleton, Spinner } from '@intigral/shared';

export const EPGTvScreen = () => {
    const dispatch = useDispatch();
    const { getDecodedSearchParams } = useCommon();
    const { userChannels, isLoading } = useSelector((state: IStore) => state.liveTv);

    // Fetch PPV config and get loading state
    const { isLoading: isPPVConfigLoading } = usePPVConfig();

    const { channelId, id, stationId, listingId, genre, startDate } = getDecodedSearchParams([
        'channelId',
        'id',
        'stationId',
        'listingId',
        'genre',
        'startDate',
    ]);

    useEffect(() => {
        // Only fetch channels after PPV config is loaded (or if it failed to load)
        if (!isPPVConfigLoading) {
            dispatch(fetchUserChannelsList(null));
        }
    }, [dispatch, isPPVConfigLoading]);

    if (isLoading || isPPVConfigLoading)
        return (
            <div style={{ height: '100vh' }}>
                <Skeleton />
            </div>
        );

    if (!(userChannels?.channels?.length > 0 && userChannels?.genres.length > 0)) return null;

    // passing only tageted channel to epg for testing purpose
    // const newData = {
    //     channels: userChannels.channels.slice(0, 1),
    //     genres: userChannels.genres,
    // };

    return (
        <EpgGuideContainer
            searchParameters={{ channelId, id, stationId, listingId, genre, startDate }}
            userChannels={userChannels}
        />
    );
};
